import React from 'react';
import { Text } from '@wix/design-system';
import { useTranslation } from 'react-i18next';
import s from './Content.scss';
import classNames from 'classnames';

export const ChangePlan: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Text className={classNames(s.withDash, s.semiBold)}>
      {t('change_plan.app_sub_title')}
    </Text>
  );
};
